package com.parmartechnologies.core.feature.auth.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class FriendlyUser @OptIn(ExperimentalTime::class) constructor(
    @SerialName("business_number") val businessNumber: Int = 0,
    @SerialName("user_id") val UserID: String = "",
    @SerialName("password") var Password: String = "",
    @SerialName("role_type") val roleType: String = "",
    @SerialName("app_id") val appID: String = "",
    @SerialName("business_type_id") val businessTypeID: String = "",
    @SerialName("is_deleted") val IsDeleted: Int = 0,
    @SerialName("name") val Name: String = "",
    @SerialName("address") val Address: String = "",
    @SerialName("product_types") val ProductTypes: ArrayList<String> = arrayListOf(),
    @SerialName("status") val Status: String = "",
    @SerialName("email_id") val EmailID: String = "",
    @SerialName("mobile_number") val MobileNumber: String = "",
    @SerialName("dial_code") val DialCode: String = "",
    @SerialName("whatsapp") val WhatsApp: String = "",
    @SerialName("gender") val Gender: Int = 0,
    @SerialName("device_id") val DeviceID: String = "",
    @SerialName("fcm_token") val FCMToken: String = "",
    @SerialName("profile_picture") val ProfilePicture: String = "",
    @SerialName("job_type_id") var JobTypeId: String = "",
    @SerialName("job_type_name") var JobTypeName: String = "",
    @SerialName("last_seen") val LastSeen: String = "",
): BaseDataClass()


